import { render, staticRenderFns } from "./CheckinIdentification.vue?vue&type=template&id=3aab3ae5"
import script from "./CheckinIdentification.vue?vue&type=script&lang=js"
export * from "./CheckinIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports